import { RED_300, GREEN_400, getTestId, BLACK_200, GREEN_500, YELLOW_100 } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  callout: {
    title: 'Put title here',
    description: 'Put description here',
    showCrossDismissBtn: false,
    iconName: 'InfoIcon',
    state: 'warning'
  },
  showDivider: true,
  infoSummaryProps: {
    detailsDataCardList: [{
      titleText: 'Overutlisation Limit 80% of 310 Mbps ',
      descriptionText: 'You are viewing this graph on 5min average. The count is based on 5 min. data points',
      showKeyBenefitsSection: true,
      numberOfColumns: 2,
      tertiaryCTAProps: {
        size: 'md',
        title: 'Update Limit',
        buttonType: 'tertiary',
        version: 'variable-width',
        onLeftCtaPress: {
          id: 'tertiary-cta'
        }
      }
    }]
  },
  dropdownArray: [Object.assign({
    dropdownFilterKey: 'filter',
    dropdownList: [{
      disabled: true,
      heading: 'heading1',
      subHeading: 'subHeading1',
      value: 'value1'
    }, {
      heading: 'heading2',
      subHeading: 'subHeading2',
      value: 'value2'
    }, {
      heading: 'heading3',
      subHeading: 'subHeading3',
      value: 'value3'
    }, {
      heading: 'heading4',
      subHeading: 'subHeading4',
      value: 'value4'
    }, {
      heading: 'heading5',
      subHeading: 'subHeading5',
      value: 'value5'
    }, {
      heading: 'heading6',
      subHeading: 'subHeading6',
      value: 'value6'
    }],
    onSelectMetaData: {},
    placeholder: 'Filter',
    postfixIconName: 'DownChevronIcon',
    variantPosition: 'left',
    filterKey: 'heading'
  }, getTestId('DropdownWidgetContainer')), Object.assign({
    dropdownFilterKey: 'search',
    dropdownList: [{
      disabled: true,
      heading: 'heading1',
      subHeading: 'subHeading1',
      value: 'value1'
    }, {
      heading: 'heading2',
      subHeading: 'subHeading2',
      value: 'value2'
    }, {
      heading: 'heading3',
      subHeading: 'subHeading3',
      value: 'value3'
    }, {
      heading: 'heading4',
      subHeading: 'subHeading4',
      value: 'value4'
    }, {
      heading: 'heading5',
      subHeading: 'subHeading5',
      value: 'value5'
    }, {
      heading: 'heading6',
      subHeading: 'subHeading6',
      value: 'value6'
    }],
    onSelectMetaData: {},
    placeholder: 'search',
    postfixIconName: 'DownChevronIcon',
    variantPosition: 'left',
    filterKey: 'heading'
  }, getTestId('DropdownWidgetContainer'))],
  graphData: {
    data: [{
      number: '8',
      name: 'Async Logic',
      color: 'beige'
    }, {
      number: '7',
      name: 'Functional JS',
      color: RED_300
    }, {
      number: '10',
      name: 'ES6+',
      color: GREEN_400
    }, {
      number: '23',
      name: 'React.js',
      color: BLACK_200
    }, {
      number: '37',
      name: 'Node.js',
      color: GREEN_500
    }, {
      number: '24',
      name: 'Closures',
      color: YELLOW_100
    }],
    showBigNumber: false,
    showDetails: true,
    columnNumber: 2
  },
  graphType: 'DONUT'
}, getTestId('GraphWidgetContainer'));